import React, { useMemo } from 'react'
import classnames from 'classnames'
import { Link } from '@reach/router'
import PropTypes from 'prop-types'

import Placeholder1 from '_assets/images/placeholder-1.png'
import UserPlaceholderIcon from '_assets/icons/user-placeholder.svg'
import Check from '_assets/icons/check.svg'
import { FLAG_MULTIPLE_COACHES } from '_config/environment'
import Svg from '_components/svg'
import { classShape } from '_utils/proptypes'

import styles from './styles.css'

const ClassCardWithNextAssignment = ({ className, course }) => {
  const instructors = useMemo(() => course?.instructors, [course])
  const isCompleted = useMemo(() => course?.completed, [course])
  const classUrl = useMemo(() => `/class/${course?.id}`, [course])

  const slicedInstructors = useMemo(() => {
    if (!instructors.length) {
      return null
    }

    return instructors
      ?.slice(0, 3)
      ?.map(instructor =>
        instructor.photo ? (
          <img
            key={`instructor-${instructor.id}`}
            alt="Coach Avatar"
            src={instructor.photo}
            className={styles['class-coach-avatar']}
          />
        ) : (
          <Svg
            icon={UserPlaceholderIcon}
            key={`instructor-${instructor.id}`}
            className={classnames(
              styles['class-coach-avatar'],
              styles['class-coach-avatar-placeholder']
            )}
          />
        )
      )
  }, [instructors])

  return (
    <article
      className={classnames(styles['class-wrapper'], className, {
        [styles['has-completed']]: isCompleted,
      })}
    >
      <div className={styles['content-wrapper']}>
        <h1 className={classnames(styles.text, styles['class-category'])}>{course.category}</h1>
        <h2 className={classnames(styles.text, styles['class-name'])}>{course.name}</h2>
        {FLAG_MULTIPLE_COACHES && instructors.length ? (
          <p className={styles['class-coache-wrapper']}>
            {slicedInstructors}
            <span className={classnames(styles.text, styles['class-coach-text'])}>
              with <strong>{instructors[0]?.name}</strong>{' '}
              {instructors?.length > 1 && `and ${instructors?.length - 1} more`}
            </span>
          </p>
        ) : null}
        <Link to={classUrl} className={styles.link} />
      </div>
      <Link to={classUrl} className={styles['image-container']} aria-label="Open assignment">
        <img
          alt="Course Thumbnail"
          src={course.coverPhoto || Placeholder1}
          className={styles.image}
        />
      </Link>
      {isCompleted && (
        <Link to={classUrl} className={styles['next-assignment-wrapper']}>
          <>
            <svg className={styles['check-icon']} viewBox={Check.viewBox} aria-hidden="true">
              <use xlinkHref={`#${Check.id}`} />
            </svg>
            <span className={styles['completed-title']}>Completed</span>
          </>
        </Link>
      )}
    </article>
  )
}

ClassCardWithNextAssignment.propTypes = {
  className: PropTypes.string,
  course: classShape.isRequired,
}

ClassCardWithNextAssignment.defaultProps = {
  className: '',
}

export default React.memo(ClassCardWithNextAssignment)
